// General
import React, { Component } from 'react';
import { Text, Whitespace } from '../common';
import Button from '../common/FormComponents/Button';
import history from '../../core/history';
import SocialShare from '../../components/ViewListing/SocialShare/SocialShare';

class Success extends Component {
  render() {
    const {
      store: { listId, title },
    } = this.props;
    return (
      <div className="f-cc f-rows height-100p">
        <Text
          fontSize="5xl"
          thin
          primaryDark
          noclip
          letterSpacing="-.5px"
          style={{
            lineHeight: '48px',
          }}
          mb={4}
        >
          You have successfuly published your listing
        </Text>
        <div className="f f-rows">
          <Whitespace />
          <SocialShare
            listId={listId}
            header="Share your listing: "
            title={title}
          />
          <Whitespace />
          <Text h4>Then: </Text>
          <Whitespace smaller />
          <div className="f-1">
            <Button
              primary
              action
              onClick={() => history.push('/details/' + listId)}
            >
              View Listing
            </Button>
          </div>
          <Whitespace smaller />
          <div className="f-1">
            <Button
              secondary
              action
              onClick={() => history.push('/add-listing/?mode=new')}
            >
              Add another listing
            </Button>
          </div>
          <Whitespace smaller />
          <div className="f-1">
            <Button
              secondary
              action
              onClick={() =>
                history.push('/add-listing/' + listId + '/review?editing=true')
              }
            >
              Back to editing
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Success.js